import { styled } from '@mui/material/styles'

export const Description = styled('span')({
  textAlign: 'left',
})
